import { COLORS } from 'consts/colors'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { RADII, SHADOWS } from 'styles/consts'
import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { StyleItem } from './Item/styled'
import styled, { css } from 'styled-components'

interface IStyleItemProps {
  $isSelected: boolean
  $isDefaultStyle?: boolean
}

export const ImageStylesContainer = styled.div`
  min-width: 430px;
  height: 635px;
  max-height: calc(100dvh);
  padding: 16px 12px 16px 16px;

  box-shadow: ${SHADOWS.menu};
  border-radius: ${RADII.card};
  background-color: ${COLORS.white};

  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    max-height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
    height: auto;
    min-width: auto;
    box-shadow: none;
  }
`

export const ImageStylesOverflow = styled.div`
  overflow: hidden scroll;
  ${customizeVerticalScrollbarThumbMixin()}

  height: 50%;
  flex: 1;
`

export const ImageStylesContentWrapper = styled.div`
  padding-right: 4px;

  display: grid;
  gap: 6px;
  grid-template-columns: repeat(3, minmax(128px, 1fr));

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    grid-template-columns: repeat(auto-fill, minmax(108px, 1fr));
    gap: 8px;
  }
`

export const NotSelectedStyleItem = styled(StyleItem)<IStyleItemProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      border: 1px solid ${COLORS.borderColor};
    `}
`
